import Favicon from "./Favicon";
import Nameplate from "./Nameplate";

export { Favicon, Nameplate, defineElements };

/**
 *
 */
function defineElements() {
  Favicon.define();
  Nameplate.define();
}
